import { ContextType, useContext } from "react";

import { AxiosContext } from "../contexts/axios";

export function useAxios(): ContextType<typeof AxiosContext> {
  return useContext(AxiosContext);
}
